import { getToday, oneYearBefore } from '@/utils/formatTime';
import moment from 'moment';

export const defaultValuesIRMarketEnvironment = {
  currency: '1',
  irIndex: 78,
  years: 7,
  swapTenors: [],
  startDate: '',
  endDate: '',
  runDates: [''],
};

export const defaultValuesDebtHedgeSchedule = {
  companyEntity: null,
  debts: '',
  trades: '',
  debtStartDate: '',
  debtEndDate: '',
  frequency: 'Quarterly',
  amortRate: 0,
  notionalCurrency: null,
  notionalAmount: 0,
  runDate: getToday(),
  hedgePercentage: '0.50,0.75',
  hedgeStartDate: oneYearBefore(),
  hedgeEndDate: getToday(),
};

export const defaultValuesPricingSummary = {
  currency: { value: '1', label: 'USD' },
  irIndex: { value: 78, label: 'LIBOR 3M' },
  runDate: '',
  frequency: { value: 'Quarterly', label: 'Quarterly' },
  notional: 100000000,
  fundingSpread: 500,
  normalVolAdjustment: 5,
  floorStrike: 1,
  cap: true,
  swap: true,
  swapFloor: true,
  capMode: false,
  capStrikesList: '4.5, 5, 5.5',
  capStrikesAtmBpsList: '50, 100, 150',
  zeroCostCollar: false,
  hedgePercentage: '0.75',
  cftt: false,
  amortRate: 0,
  dayCount: 360,
  enable_hedge_breakage: false,
  debt_and_hedge_enabled: false,
  graphGroups: {
    1: {
      effectiveDate: moment().endOf('year').format('YYYY-MM-DD'),
      maturityDate: moment().add(3, 'years').endOf('year').format('YYYY-MM-DD'),
      swapCharge: '',
      graph: true,
      breakage: [],
    },
  },
};

export const defaultValuesCashflowThroughTime = {
  dayCount: 360,
  companyEntity: null,
  debts: '',
  trades: '',
  runDate: '',
};

export const frequencyOptions = [
  { value: 'Annual', label: 'Annual' },
  { value: 'Semi-annual', label: 'Semi-Annual' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Monthly', label: 'Monthly' },
];

export const SAVE_USER_WIDGET_DATA_MODAL_ID = 'save_user_widget_data_modal_id';
export const INFO_WIDGET_DATA_MODAL_ID = 'INFO_WIDGET_DATA_MODAL_ID';
